import { TestCase } from '../../../../types/testCase';
import { RequirementTrace } from '../../../../types/trace';

export function isRequirement(el: RequirementTrace | TestCase): el is RequirementTrace {
  return ['req1', 'req2', 'req3'].includes(el.type);
}
